module.exports = __webpack_public_path__ + "media/images/third_party_logos/The_Boston_Globe-7e27c1fa87e3ca40b6e58abb7621e852.png";